<template>
    <tr class="lms__superadmin_customer_edit_emailsenders_table_item_add">
        <td class="lms__superadmin_customer_edit_emailsenders_table_item_add_emailaddress">
            <form-email
                :label="''"
                :name="'lms-superadmin-customer-edit-email-senders-table-item-add-email-address'"
                :data-vv-as="'email address'"
                :required="true"
                :v-validate="'required'"
                v-model="senderEmailAddress"
            >e.g. joe.smith@domain.co.uk</form-email>
        </td>
        <td class="lms__superadmin_customer_edit_emailsenders_table_item_add_status">
            <component-status :status="'not-created'"></component-status>
        </td>
        <td class="lms__superadmin_customer_edit_emailsenders_table_item_add_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'lms-superadmin-customer-edit-email-senders-table-item-test-action'"
                        :animate-loading="true"
                        :animate-loading-event-name="'email-sender-submit'"
                        @click="performCreateEmailSender"
                    >Submit
                    </component-button>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'lms-superadmin-customer-edit-email-senders-table-item-test-action'"
                        :icon="true"
                        :icon-name="'x'"
                        :theme="'default'"
                        @click="performCloseEmailSenderField"
                    ></component-button>
                </div>
            </div>
        </td>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </tr>
</template>

<script>

import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormEmail from '@/components/default/forms/FormEmail'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'lms-superadmin-customer-edit-email-senders-table-item-add',
  components: { PopNotify, FormEmail, ComponentButton, ComponentStatus },
  data () {
    return {
      senderEmailAddress: ''
    }
  },
  computed: {
    customerId () {
      return this.$route.params.id
    }
  },
  methods: {
    performCreateEmailSender () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('lmsSuperadminCustomerEmailSendersCreate', { customerId: this.customerId, emailAddress: this.senderEmailAddress }).then(() => {
            this.$emit('emit', { message: 'emit-perform-get-items' })
            this.senderEmailAddress = ''
          }).finally(() => {
            this.$eventBus.$emit('stop-email-sender-submit')
          })
        } else {
          this.$refs.popnotifyvalidation.openNotify()
          this.$eventBus.$emit('stop-email-sender-submit')
        }
      })
    },
    performCloseEmailSenderField () {
      this.$eventBus.$emit('close-email-sender-field')
    }
  }
}
</script>
